import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {Loner} from "../../Loner";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {LonerBitmapCountUp} from "../../components/LonerBitmapCountUp";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";

export class LonerWinWaysView extends PIXI.Container implements StageLayer {

    private static CONTAINER_POSITION: PIXI.Point = new PIXI.Point(360, 360);
    private static BLACK_PADDING: PIXI.Point = new PIXI.Point(30, 10);

    private _toggleAmount: LonerBitmapCountUp;
    private _toggleWays: PIXI.Text;
    private _toggleWaysBackground: PIXI.Sprite;
    private _toggleWaysContainer: PIXI.Container;
    private _toggleContainer: PIXI.Container;

    constructor() {
        super();
        this.name = "LonerWinWaysView";

        this.init();
    }

    private init(): void {
        this._toggleContainer = new PIXI.Container();
        this._toggleContainer.position = LonerWinWaysView.CONTAINER_POSITION;
        this.addChild(this._toggleContainer);

        this._toggleAmount = new LonerBitmapCountUp(46, 700);
        this._toggleAmount.position.y = -50;
        this._toggleWaysContainer = new PIXI.Container();
        this.addChild(this._toggleWaysContainer);
        this._toggleWaysBackground = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._toggleWaysBackground.tint = 0x000000;
        this._toggleWaysBackground.anchor.set(0.5, 0.5);
        this._toggleWaysBackground.position.x = 6;
        this._toggleWaysBackground.position.y = 3;
        this._toggleWaysBackground.alpha = 0.9;
        this._toggleWaysContainer.addChild(this._toggleWaysBackground);

        this._toggleWays = new PIXI.Text("", new PIXI.TextStyle({
            fontFamily: OpenSans.FAMILY,
            fill: "#EAEAEA",
            fontSize: 40
        }));
        this._toggleWays.anchor.set(0.5);
        this.setYPosWays(55);
        this._toggleWays.alpha = 0.8;
        this._toggleWaysContainer.addChild(this._toggleWays);
        this._toggleContainer.alpha = 0;

        this._toggleContainer.addChild(this._toggleWaysContainer, this._toggleAmount);
    }

    public setYPosWays(yPos: number): void {
        this._toggleWaysContainer.position.y = yPos;
    }

    public showInitialWinWays(): void {
        const ways: number = Loner.model.totalWaysWon,
            text: string = (ways === 1 ? "Way Won" : "Ways Won");

        this._toggleWays.text = ways + " " + Loner.apiPlugin.translations.translate(text).toLowerCase();
        this.updateToggleWaysBackground();
        this._toggleContainer.alpha = 1;
        //Hiding this since Initial win has it's own
        this._toggleAmount.visible = false;
        this.visible = true;
    }

    private updateToggleWaysBackground(): void {
        this._toggleWaysBackground.width = this._toggleWays.width + LonerWinWaysView.BLACK_PADDING.x;
        this._toggleWaysBackground.height = this._toggleWays.height + LonerWinWaysView.BLACK_PADDING.y;
    }

    public getToggleWinTL(amount: number, ways: number, fadeInDuration: number = 0.001): gsap.core.Timeline {
        const text: string = (ways === 1 ? "Way Won" : "Ways Won");
        const toggleTL: gsap.core.Timeline = gsap.timeline();
        if (Loner.model.brokeBank == true){
            if (Loner.model.isNaturalMaxWin == false) {
                this._toggleWaysContainer.visible = false;
            }
        }

        toggleTL.add(()=>{this._toggleAmount.preCalculateScale(amount, amount)});
        toggleTL.add(() => this._toggleAmount.forceSetText(SlotGame.apiPlugin.currency.formatValue(amount)));
        toggleTL.add(() => {
            this._toggleContainer.alpha = 0;
            this._toggleAmount.visible = true;
        });
        toggleTL.add(() => {
            this._toggleWays.text = ways + " " + Loner.apiPlugin.translations.translate(text).toLowerCase();
            this.updateToggleWaysBackground();
            this._toggleAmount.startFlicker();
            this.visible = true;
        });

        toggleTL.add(gsap.to(this._toggleContainer, {
            duration: fadeInDuration,
            alpha: 1
        }));

        return toggleTL;
    }

    public forceSetWays(ways: number): void {
        const text: string = (ways === 1 ? "Way Won" : "Ways Won");
        this._toggleWays.text = ways + " " + Loner.apiPlugin.translations.translate(text).toLowerCase();
        this.updateToggleWaysBackground();
    }

    public getHideToggleWin(fadeOutDuration:number=0.001): gsap.core.Timeline {
        const hideTL: gsap.core.Timeline = gsap.timeline();
        hideTL.add(gsap.to(this._toggleContainer, {
            duration: fadeOutDuration,
            alpha: 0
        }));
        hideTL.add(() => {
            this._toggleAmount.stopFlicker();
        });
        hideTL.add(() => {
            this.visible = false;
        });
        return hideTL;
    }

    public reset(): void {
        this.visible = false;
        this._toggleAmount.stopFlicker();
        this._toggleWaysContainer.visible = true;
    }

    get toggleAmount(): LonerBitmapCountUp {
        return this._toggleAmount;
    }
}